
export default [
    { id: "1", count: 1, header: 'SERVICES_NAME_1', description: "SERVICE_DESCRIPTION_1", },
    { id: "2", count: 2, header: 'SERVICES_NAME_2', description: "SERVICE_DESCRIPTION_2", },
    { id: "3", count: 0, header: 'SERVICES_NAME_3', description: "SERVICE_DESCRIPTION_3", },
    // { id: "4", count: 2, header: 'SERVICES_NAME_4', description: "SERVICE_DESCRIPTION_4", },
    // { id: "5", count: 4, header: 'SERVICES_NAME_5', description: "SERVICE_DESCRIPTION_5", },
    // { id: "6", count: 2, header: 'SERVICES_NAME_6', description: "SERVICE_DESCRIPTION_6", },
    // { id: "7", count: 1, header: 'SERVICES_NAME_7', description: "SERVICE_DESCRIPTION_7", },
    // { id: "8", count: 2, header: 'SERVICES_NAME_8', description: "SERVICE_DESCRIPTION_8", },
    // { id: "9", count: 2, header: 'SERVICES_NAME_9', description: "SERVICE_DESCRIPTION_9", },
    // { id: "10", count: 12, header: 'SERVICES_NAME_10', description: "SERVICE_DESCRIPTION_10", },
    // { id: "11", count: 2, header: 'SERVICES_NAME_11', description: "SERVICE_DESCRIPTION_11", },
]